export default {
  SET_KEYWORDS: (state, payload) => {
    state.keywords = payload;
  }

  // TODO: for scope change purposes
  // SET_SCOPE: (state, payload) => {
  //   state.scope = payload;
  // }
};
